import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';

import MuiButton from '@material-ui/core/Button';
import MuiDialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiSelect from '@material-ui/core/Select';
import MuiMenuItem from '@material-ui/core/MenuItem';
import MuiFormControl from '@material-ui/core/FormControl';
import MuiInputLabel from '@material-ui/core/InputLabel';

import { useMutation, useQuery } from 'react-query';

import * as API from 'api';

const Groups = API.Groups();
const Releases = API.Releases();

const styles = theme => ({
  dialog: {
    width: '400px',
  },
  formRow: {
    display: 'flex',
    alignItems: 'flex-end',
    marginBottom: '10px',
  },
  select: {
    marginBottom: '4px',
    minWidth: '100px',
    width: '100%',
  },
  dialogFooter: {
    padding: theme.spacing(1.5),
  },
  fullWidth: {
    width: '100%',
  },
});

const DialogCreateRelease = ({ open, onClose, onCreate, ...props }) => {
  const { classes } = props;
  const [selectedGroup, setSelectedGroup] = useState(1);

  const { data: groups, isLoading } = useQuery(['groups'], Groups.getAllSegmented);
  const { mutate: createRelease, isLoading: isCreating } = useMutation(group => Releases.create(group), {
    onSuccess: onCreate,
  });

  return (
    <MuiDialog open={open} onClose={onClose} aria-labelledby="form-dialog-title">
      <MuiDialogTitle id="form-dialog-title">Create Release</MuiDialogTitle>
      <MuiDialogContent className={classes.dialog}>
        <MuiFormControl className={classes.select}>
          <MuiInputLabel>Group *</MuiInputLabel>
          <MuiSelect
            disabled={isCreating}
            value={selectedGroup}
            onChange={({ target: { value } }) => setSelectedGroup(value)}>
            {!isLoading &&
              groups.map(group => (
                <MuiMenuItem key={group.id} value={group.id}>
                  {group.name}
                </MuiMenuItem>
              ))}
          </MuiSelect>
        </MuiFormControl>
      </MuiDialogContent>
      <MuiDialogActions className={classes.dialogFooter}>
        <MuiButton disabled={isCreating} variant="contained" onClick={onClose}>
          Cancel
        </MuiButton>
        <MuiButton
          disabled={isCreating}
          variant="contained"
          color="primary"
          onClick={() => createRelease(selectedGroup)}>
          Create Blank Release
        </MuiButton>
      </MuiDialogActions>
    </MuiDialog>
  );
};

export default withStyles(styles)(DialogCreateRelease);
